import { render, staticRenderFns } from "./GenArtSearchResult.vue?vue&type=template&id=2ac689e9&scoped=true"
import script from "./GenArtSearchResult.vue?vue&type=script&lang=js"
export * from "./GenArtSearchResult.vue?vue&type=script&lang=js"
import style0 from "./GenArtSearchResult.vue?vue&type=style&index=0&id=2ac689e9&prod&lang=less"
import style1 from "./GenArtSearchResult.vue?vue&type=style&index=1&id=2ac689e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac689e9",
  null
  
)

export default component.exports